import { useIntl } from 'react-intl';
import { useConfigContext } from '@fe-core';

function getAfterLoginUrl() {
  const url = new URL(window.location.href);
  url.searchParams.set('op', 'enroll');

  return url.toString();
}

export const LoginAction = () => {
  const intl = useIntl();
  const { config } = useConfigContext();

  const loginHref = `${config?.baseUrls?.login}?redirect=${encodeURIComponent(getAfterLoginUrl())}`;

  return (
    <a className="lf:l-btn lf:l-btn-md lf:l-btn-primary" href={loginHref}>
      {intl.formatMessage({ id: 'catalog.selfreg.login' })}
    </a>
  );
};
